// extracted by mini-css-extract-plugin
module.exports = {"Imprint":"imprintPrivacy_Imprint__1wGn7","Privacy":"imprintPrivacy_Privacy__IPDe5"};